<template>
  <div class="mt-4 px-4 container-fluid">
    <div class="breadcrumb text-md px-0 mb-4">
      <p><span class="breadcrumb-item" @click="irInicio">Inicio</span> > Tipsters</p>
    </div>
  </div>

  <div class="px-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card ficha-buscador">
          <div class="titulo"><h5 class="mx-4 mt-5 mb-5">Listado de Tipsters</h5></div>
          <div class="table-search">
            <input id="textoBuscador" type="text" class="form-control" placeholder="Búsqueda rápida..." aria-label="Búsqueda rápida" @input="teclearBuscador" />
          </div>
          <div class="descarga doble">
            <p @click="descargarCSV"><i class="fa fa-download" aria-hidden="true"></i></p>
            <p @click="abrirAltaTipster"><i class="fa fa-plus" aria-hidden="true"></i></p>
          </div>
          <div class="borrados">
            <QToggle v-model="mostrarBorrados" @change="cambiarBorrados" />
            <span class="borrados-label">{{ mostrarBorrados ? 'Con eliminados' : 'Sin eliminados' }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="px-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card ficha-listado mt-4">
          <div class="px-4 pb-0 card-body">
            <div class="table-responsive mb-4">
              <table id="tipster-list" class="table table-flush table-listado">
                <thead class="thead-light">
                  <tr>
                    <th @click="sortTable('0')" :class="sortColumn=='0' ? sortDirection : ''">Nombre</th>
                    <th @click="sortTable('1')" :class="sortColumn=='1' ? sortDirection : ''" class="d-none d-md-table-cell">Contacto</th>
                    <th @click="sortTable('2')" :class="sortColumn=='2' ? sortDirection : ''">Email</th>
                    <th @click="sortTable('3')" :class="sortColumn=='3' ? sortDirection : ''" class="d-none d-md-table-cell">Teléfono</th>
                    <th @click="sortTable('4')" data-type="date" data-format="DD/MM/YYYY" :class="sortColumn=='4' ? sortDirection : ''" class="d-none d-md-table-cell">Creado</th>
                    <th @click="sortTable('5')" :class="sortColumn=='5' ? sortDirection : ''" class="d-none d-md-table-cell" v-if="mostrarBorrados">Eliminado</th>
                    <th data-type="html" data-sortable="false" class="sin-orden">Acciones</th>
                  </tr>
                </thead>
                <tbody class="text-sm">
                  <!-- Ciclo a través de los elementos filtrados y paginados -->
                  <tr v-for="row in filas" :key="row.id">
                    <td>{{ row.nombre }}</td>
                    <td class="d-none d-md-table-cell">{{ row.contacto }}</td>
                    <td>{{ row.email }}</td>
                    <td class="d-none d-md-table-cell">{{ row.telefono }}</td>
                    <td class="d-none d-md-table-cell">{{ row.created }}</td>
                    <td class="d-none d-md-table-cell" v-if="mostrarBorrados">{{ row.deleted }}</td>
                    <td>
                      <template v-if="!row.deleted">
                        <a href="#" class="cursor-pointer me-3" title="Editar Tipster" @click.prevent="editarTipster(row.id)">
                          <i class="fas fa-edit text-secondary"></i>
                        </a>
                        <a href="#" class="cursor-pointer me-3" title="Eliminar Tipster" @click.prevent="mostrarConfirmacionBorrar(row.id)">
                          <i class="fas fa-trash text-secondary"></i>
                        </a>
                      </template>
                    </td>
                  </tr>
                  <tr v-if="filas.length==0"><td colspan="7">No hay registros que mostrar</td></tr>
                </tbody>
              </table>
            </div>
            <!-- Control de la Paginacion manual -->
            <div class="paginacion" v-if="filas.length>0">
              <p class="contador-listado">Mostrando {{ mostradosIni }} a {{ mostradosFin }} de {{ mostradosTotal }} registros</p>

              <ul class="pagination pagination-md" v-if="paginaTotal>1">
                <li class="page-item prev-page" v-if="paginaActual>1">
                  <a class="page-link" aria-label="Previous" @click="paginaActual=paginaActual-1;fetchAndSetTipsters();">
                    <i class="fa fa-angle-left" aria-hidden="true"></i>
                  </a>
                </li>
                <li v-for="index in rangoPaginas" :key="index" class="page-item" :class="index==paginaActual ? 'active disabled' : ''">
                  <a class="page-link" @click="paginaActual=index;fetchAndSetTipsters();">{{index}}</a>
                </li>
                <li class="page-item next-page" v-if="paginaActual<paginaTotal">
                  <a class="page-link" aria-label="Next" @click="paginaActual=paginaActual+1;fetchAndSetTipsters();">
                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <Modal @cerrar-modal="cerrarModal" :modalActive="modalActive">
    <div class="modal-content">
      <alta-tipster-form v-if="tipoModal=='A'" @cerrar-modal="() => { this.modalActive=false;fetchAndSetTipsters();}" :key="0"></alta-tipster-form>
      <edita-tipster-form v-if="tipoModal=='E'" @cerrar-modal="() => { this.modalActive=false;fetchAndSetTipsters();}" :key="tipsterEditId" :tipsterId="tipsterEditId" :tipsterName="tipsterEditName" :tipsterEmail="tipsterEditemail" :tipsterContacto="tipsterEditcontacto" :tipsterTelefono="tipsterEdittelefono"></edita-tipster-form>
    </div>
  </Modal>

  <div v-if="confirmacionVisible" class="overlay">
    <div class="confirm-box">
      <p class="mt-4 mb-4">{{ mensajeConfirmacion }}</p>
      <table class="mt-4 mb-4"><tr>
        <td width="50%"><QBtn variant="cancela" label="Cancelar" @click="cancelacion" /></td>
        <td width="50%"><QBtn variant="confirma" label="Confirmar" @click="confirmacion" /></td>
      </tr></table>
    </div>
  </div>

</template>

<script>
import showSwal from "@/mixins/showSwal.js";
import Modal from './components/Modal.vue';
import AltaTipsterForm from './components/AltaTipsterForm.vue';
import EditaTipsterForm from './components/EditaTipsterForm.vue';
import {globalFunctionsMixin} from '@/mixins/globalFunctions.js';

export default {
  name: "Tipsters",
  components: {
    Modal,
    AltaTipsterForm,
    EditaTipsterForm,
  },
  mixins: [globalFunctionsMixin],
  data() {
    return {
      filas: [],
      tipsters: [],
      confirmacionVisible: false,
      tipsterId: 0,
      mensajeConfirmacion: '',
      tipoModal: '',
      tipsterEditId: 0,
      tipsterEditName: '',
      tipsterEditemail: '',
      tipsterEditcontacto: '',
      tipsterEdittelefono: '',
      textoBuscador: '',
      paginaActual: 0,
      paginaTotal: 0,
      mostrarBorrados: false,
      mostradosIni: 0,
      mostradosFin: 0,
      mostradosTotal: 0,
      sortColumn: 0,
      sortDirection: '',
      modalActive: false,
      searchTimeout: null,
    };
  },
  computed: {
    rangoPaginas() {
      let startPage = Math.max(this.paginaActual - 3, 1);
      let endPage = Math.min(this.paginaActual + 3,this.paginaTotal);
      let pages = [];
      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }
      return pages;
    }
  },
  methods: {
    alert() {
      showSwal.methods.showSwal({
        type: "error",
        message: "This is a PRO feature.",
        width: 400,
      });
    },

    async descargarCSV() {
      try {
        const response = await this.$store.dispatch("auth/exportarTipsters");
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "tipsters_" + new Date().toISOString().slice(0, 10) + ".xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (e) {
        showSwal.methods.showSwal({ type: "error", message: "No se pudo generar el archivo.", width: 400 });
      }
    },

    async initializeDataTable() {
      this.sortColumn=4;
      this.sortDirection='desc';
      this.textoBuscador = '';  
      this.paginaActual = 1;
      await this.fetchAndSetTipsters();
    },

    sortTable(key) {
      // Alternar entre ascendente y descendente al hacer clic en el encabezado
      if (this.sortColumn === key) {
        this.sortDirection = this.sortDirection=='asc' ? 'desc' : 'asc';
      } else {
        this.sortColumn = key;
        this.sortDirection = 'asc';
      }
      this.fetchAndSetTipsters();
    },

    teclearBuscador(event) {
      this.textoBuscador = event.target.value;
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.fetchAndSetTipsters();
      }, 500);
    },

    async fetchAndSetTipsters() {
      try {
        // Petición al servidor
        const response = await this.$store.dispatch("auth/tipsters", { textoBuscador: this.textoBuscador, paginaActual: this.paginaActual, mostrarBorrados: this.mostrarBorrados, sortColumn: this.sortColumn, sortDirection: this.sortDirection  }); 
        this.tipsters = response.data;

        // Procesar los datos y actualizarlos en el DataTable
        this.filas = response.data.map(row => ({
          id: row.id,
          nombre: row.nombre,
          contacto: row.contacto,
          email: row.email,
          telefono: row.telefono,
          created: this.formatDate(row.created_at, 'DD/MM/YYYY'),
          deleted: row.deleted_at ? this.formatDate(row.deleted_at, 'DD/MM/YYYY') : '',
        }));

        this.paginaTotal = response.paginas;
        this.mostradosIni = (response.actual-1)*response.porpagina + 1;
        this.mostradosFin = Math.min(response.totales,response.actual*response.porpagina);
        this.mostradosTotal = response.totales;

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    },

    mostrarConfirmacionBorrar(id) { 
      this.confirmacionVisible = true;
      this.tipsterId = id;
      this.mensajeConfirmacion = '¿Confirma que desea eliminar este tipster?';
    },
    confirmacion() {
      this.confirmacionVisible = false;
      this.borrarTipster(this.tipsterId);
    },
    cancelacion() {
      this.confirmacionVisible = false;
    },
    editarTipster(id) {
      const tipster = this.tipsters.find(r => r.id == id);
      if (!tipster) return;
      this.modalActive = true;
      this.tipoModal = 'E';
      this.tipsterEditName = tipster.nombre;
      this.tipsterEditemail = tipster.email;
      this.tipsterEditcontacto = tipster.contacto;
      this.tipsterEdittelefono = tipster.telefono;
      this.tipsterEditId = tipster.id;
    },
    async abrirAltaTipster() {
      this.modalActive = true; 
      this.tipoModal = 'A';
    },
    cerrarModal() {
      this.modalActive = false;
    },
    async cambiarBorrados() {
      await this.initializeDataTable();
    },
    async borrarTipster(tipsterId) {
      try {
        const resp =  await this.$store.dispatch("auth/borraTipster",{id: tipsterId});
        if (resp.res=='OK') {
            showSwal.methods.showSwal({
                type: "success",
                message: resp.mensaje,
                width: 600,
            });
            this.fetchAndSetTipsters();
            this.$emit('cerrar-modal');
        }
        else {
            showSwal.methods.showSwal({
                type: "error",
                message: resp.mensaje,
                width: 500
            });               
        }
      } 
      catch (error) {
        showSwal.methods.showSwal({
            type: "error",
            message: "Se ha producido un error",
            width: 500,
        });
      }
    },
    irInicio() {
      this.$router.push('/dashboard');
    }
  },

  async mounted() { 
    this.$store.commit('setShowFooter', true);
    this.initializeDataTable();
  },

};
</script>

<style scoped>
.borrados {
  display: flex;
  align-items: center;
  gap: 8px;
}
.borrados-label {
  font-size: 0.78rem;
  color: var(--q-muted);
  white-space: nowrap;
}
</style>



